import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-26feabea"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "musicList"
};
var _hoisted_2 = {
  class: "newMusic-list"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  key: 0,
  class: "newMusic-list-index"
};
var _hoisted_5 = {
  key: 1,
  class: "iconfont icon-icon_horn newMusic-list-index"
};
var _hoisted_6 = {
  class: "newMusic-list-right"
};
var _hoisted_7 = {
  class: "newMusic-songer linelittle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  var _directive_minTenIndex = _resolveDirective("minTenIndex");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createCommentVNode(" :style=\"{ height: itemHeight }\" "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.musicList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['newMusic-list-item', _ctx.currentId === item.id && 'active']),
      key: item.id,
      onClick: function onClick($event) {
        return _ctx.newMscItemClick(item, item.id);
      }
    }, [_createCommentVNode(" 索引,点击切换音乐图标 "), _ctx.currentId !== item.id ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [_createTextVNode(_toDisplayString(index + 1), 1
    /* TEXT */
    )])), [[_directive_minTenIndex]]) : (_openBlock(), _createElementBlock("i", _hoisted_5)), _createCommentVNode(" 图片 "), _createVNode(_component_el_image, {
      src: item.picUrl,
      style: _normalizeStyle({
        height: _ctx.itemHeight,
        width: _ctx.itemHeight
      })
    }, null, 8
    /* PROPS */
    , ["src", "style"]), _createCommentVNode(" 右边文本 "), _createElementVNode("div", _hoisted_6, [_createElementVNode("h5", null, _toDisplayString(item.rcmdText || item.name), 1
    /* TEXT */
    ), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.newMusicSonger[index] || item.name), 1
    /* TEXT */
    )])], 10
    /* CLASS, PROPS */
    , _hoisted_3);
  }), 128
  /* KEYED_FRAGMENT */
  ))])]);
}